<template>
  <list-template
    :search-config="searchConfig"
    :table-config="tableConfig"
    :table-data="tableData"
    :total="total"
    :loading="loading"
    :current-page="page"
    @onChangePage="handleCurrentChange"
    @onHandle="handleClick"
    @onChange="onChange"
    @onExportData="handDownload"
    @onBatchImport="handleUpload"
    @onAdd="handleAdd"
    @onSearch="onSearch"
    @onReset="onReset"
  />
</template>

<script>
import { tableListMixin } from '@/utils/mixins'
import { setConfigOption } from '@/utils'
import http, { fileDownload, changeObjToArr, get_grade2, get_class2 } from '@/api'
export default {
  _config: {"route": {"path": "list", "meta": {"title": "列表", "keepAlive": true}}},
  mixins: [tableListMixin],
  data() {
    return {
      searchConfig: [
        { tag: 'input', placeholder: '搜索学生姓名', prop: 'student_name' },
        { tag: 'input', placeholder: '搜索跟进人（班主任）', prop: 'teacher_name' },
        {
          tag: 'select',
          placeholder: '筛选校区',
          prop: 'school_id',
          options: [],
          change: (val, search) => {
            if (search.class_id) search.class_id = ''
            if (search.grade_id) this.getClass({ grade_id: search.grade_id, school_id: val })
          }
        },
        {
          tag: 'select',
          placeholder: '筛选年级',
          prop: 'grade_id',
          options: [],
          change: (val, search) => {
            if (search.class_id) search.class_id = ''
            if (search.school_id) this.getClass({ grade_id: val, school_id: search.school_id })
          }
        },
        { tag: 'select', placeholder: '筛选行政班', prop: 'class_id', options: [] },
        { tag: 'select', placeholder: '筛选客户意向', prop: 'will', options: [] },
        { tag: 'select', placeholder: '筛选跟进状态', prop: 'status', options: [] },
        { tag: 'input', placeholder: '搜索线索来源', prop: 'source_from' },
      ],
      tableConfig: [
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'school_name', label: '校区' },
        { prop: 'grade_name', label: '年级' },
        { prop: 'class_name', label: '行政班' },
        { prop: 'teacher_name', label: '跟进人（班主任）', },
        { prop: 'will_name', label: '客户意向', },
        { prop: 'status_name', label: '跟进状态' },
        { prop: 'follow_times', label: '跟进次数' },
        { prop: 'source_from', label: '线索来源' },
        { prop: 'last_time', label: '最后跟进时间' },
        { prop: 'remark', label: '备注' },
        { label: '操作', width: '120rem', handle: true }
      ],
    };
  },
  created() {
    this.getSearchConfig()
  },
  methods: {
    handleAdd() {
      this.$router.push('./add')
    },
    handDownload() {
      fileDownload('/api2/api/work/muti-study-follow/export-danzhao', {...this.search}, { name: '多元升学单招跟进', show: true })
    },
    handleClick(row, { type }) {
      const { id, student_id } = row
      if (['edit', 'view', 'approve'].includes(type)) {
        this.$router.push(`./${type}?id=${id}&student_id=${student_id}`)
      }
    },
    getData() {
      this.getDataApi('/api2/api/work/muti-study-follow/list-danzhao')
    },
    getClass(data) {
      setConfigOption({ list: this.searchConfig, data: [], key: 'class_id' })
      get_class2(data).then(res => {
        if (res && res.length) {
          const data = res.map(item => ({ value: item.class_id, label: item.class_name }))
          data.unshift({ value: '0', label: '全部' })
          setConfigOption({ list: this.searchConfig, data, key: 'class_id' })
        }
      })
    },
    getSearchConfig() {
      http({ url: '/1v1/sys-config/get', pre: 'api2' }, { key: 'muti_study_follow' }).then(res => {
        const { danzhao: { will, status } } = res
        setConfigOption({ list: this.searchConfig, data: changeObjToArr(will, true), key: 'will' })
        setConfigOption({ list: this.searchConfig, data: changeObjToArr(status, true), key: 'status' })
      })
      http({ url: '/feedback/problem/school', pre: 'api2' }, { is_entity: 1 }).then(res => {
        if (res && res.length) {
          const data = res.map(item => ({ value: item.school_id, label: item.school_name }))
          data.unshift({ value: '0', label: '全部' })
          setConfigOption({ list: this.searchConfig, data, key: 'school_id' })
        }
      })
      get_grade2().then(res => {
        if (res && res.length) {
          const data = res.map(item => ({ value: item.id, label: item.name }))
          data.unshift({ value: '0', label: '全部' })
          setConfigOption({ list: this.searchConfig, data, key: 'grade_id' })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
